import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5024c7dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_header",
  class: "header align-items-stretch"
}
const _hoisted_2 = { class: "d-flex align-items-stretch justify-content-between container-fluid" }
const _hoisted_3 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_4 = {
  class: "btn btn-icon btn-active-light-secundary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2x mt-1 text" }
const _hoisted_6 = { class: "d-flex justify-content-sm-between w-100 px-7" }
const _hoisted_7 = {
  class: "d-flex align-items-center flex-grow-sm-1 w-100",
  id: "title",
  style: {"height":"65px"}
}
const _hoisted_8 = { class: "fw-bolder fs-5 cor_texto_1 text-truncate text-concessionaria" }
const _hoisted_9 = {
  key: 1,
  class: "fw-bolder fs-5 cor_texto_1 text-truncate text-concessionaria"
}
const _hoisted_10 = {
  class: "d-flex align-items-center justify-content-end py-0 ms-3 p-2 gap-4",
  id: "kt_header_menu_nav"
}
const _hoisted_11 = {
  class: "bg-danger p-2 rounded-2 d-flex",
  style: {"min-width":"10rem"}
}
const _hoisted_12 = {
  key: 0,
  class: "text-white"
}
const _hoisted_13 = {
  key: 1,
  class: "text-white"
}
const _hoisted_14 = {
  key: 2,
  class: "text-white"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fas fa-arrow-down",
  style: {"color":"white"}
}, null, -1))
const _hoisted_16 = { class: "py-0" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = {
  class: "p-3",
  style: {"min-width":"fit-content"}
}
const _hoisted_19 = { class: "m-0" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div style=\"cursor:pointer;\" id=\"kt_header_menu_mobile_toggle\" data-v-5024c7dd><svg width=\"38\" height=\"38\" viewBox=\"0 0 38 38\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5024c7dd><rect width=\"38\" height=\"38\" rx=\"19\" fill=\"#ED2B46\" data-v-5024c7dd></rect><path d=\"M19.1252 18.0303C16.7013 18.0303 14.7363 16.0567 14.7363 13.6221C14.7363 11.1875 16.7013 9.21387 19.1252 9.21387C21.5492 9.21387 23.5142 11.1875 23.5142 13.6221C23.5142 16.0567 21.5492 18.0303 19.1252 18.0303Z\" fill=\"white\" data-v-5024c7dd></path><path d=\"M9.25078 28.1683C9.67607 22.9085 13.9263 20.2344 19.1068 20.2344C24.3601 20.2344 28.6763 22.7616 28.9978 28.1692C29.0106 28.3846 28.9978 29.0508 28.1735 29.0508C24.1077 29.0508 18.0659 29.0508 10.0483 29.0508C9.77312 29.0508 9.22761 28.4548 9.25078 28.1683Z\" fill=\"white\" data-v-5024c7dd></path></svg></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "./media/icons/duotune/abstract/abs015.svg" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                class: "item",
                effect: "dark",
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.headerTitle), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.headerTitle), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.headerTitle), 1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.ticketsWithMessages.length)
            ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketsWithMessages, (tck) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: tck,
                          onClick: ($event: any) => (_ctx.router.push({ name: 'ticketsId', params: { id: `${ tck }` } }))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Acessar ticket " + _toDisplayString(tck), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", null, [
                      (_ctx.ticketsWithMessages.length > 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.ticketsWithMessages.length), 1))
                        : _createCommentVNode("", true),
                      (_ctx.ticketsWithMessages.length > 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " novas mensagens"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "Nova mensagem"))
                    ]),
                    _hoisted_15
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_KTMenu),
          _createVNode(_component_router_view, {
            name: "filter",
            class: "me-3"
          }),
          _createVNode(_component_router_view, {
            name: "export",
            class: "me-3"
          }),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.usuario.name.split(' ').length > 2 ? `${_ctx.usuario.name.split(' ')[0]} ${_ctx.usuario.name.split(' ')[1].charAt(0)}` : _ctx.usuario.name), 1)
              ]),
              _hoisted_20
            ])
          ])
        ])
      ])
    ])
  ]))
}